// Historical API weeks use the same convention as the weekly forecasts.
export function gameWeek(game, fallback) {
  if (game.postseason) return 'Postseason';
  let value = game.week ?? fallback;
  if (value == null) {
    const raw = game.date_iso || game.date || game.kickoff_utc;
    const iso = typeof raw === 'string' && raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (iso) {
      const year = Number(iso[1]), month = Number(iso[2]), day = Number(iso[3]);
      const played = Date.UTC(year, month - 1, day);
      const september = new Date(Date.UTC(year, 8, 1));
      const laborDay = september.getTime() + ((8 - september.getUTCDay()) % 7) * 86400000;
      if (month >= 8) value = Math.max(0, 1 + Math.floor((played - laborDay + 6 * 86400000) / (7 * 86400000)));
    }
  }
  value = value ?? game.season_week ?? game.game_context?.week;
  return value == null || value === '' ? '—' : value;
}
